import { getCurrentInstance } from "vue";

type translatesStrings = (key:string, ...rest:unknown[]) => string;

/**
 * The shape of the legacy Vue instance this composable relies on: $t is mixed in
 * globally at runtime but is not present on the typed Vue 2.7 instance.
 */
type TranslatingInstance = { $t: (key: string, ...rest: unknown[]) => string };

/**
 * The translation composable.
 */
export default function useTranslation(): {
    translate: translatesStrings,
    __: translatesStrings
} {
  const $vm = getCurrentInstance()?.proxy as unknown as TranslatingInstance | undefined;
  const translate = (key:string, ...rest: unknown[]): string => $vm?.$t(key, ...rest) as string;

  return {
    translate,
    __: translate,
  };
}
